module.exports = __webpack_public_path__ + "img/zd-down-4.dcbcb376.svg";